// Design System
import { Modal } from 'jl-design-system/components/modal/Modal';

// Types
import { RewardsPromoWarningProps } from './RewardsPromoWarning.types';

export const RewardsPromoWarning = ({ direction, onContinue, onCancel }: RewardsPromoWarningProps) => {
  const directionText =
    direction === 'reward-to-promo'
      ? 'Applying your reward will remove your promo code.'
      : 'Applying your promo code will remove your reward.';

  return (
    <Modal
      isOpen
      onClose={onCancel}
      onPrimaryButtonClick={onContinue}
      onUnderlinedButtonClick={onCancel}
      primaryButtonText="Continue"
      title="Confirm"
      underlinedButtonText="Cancel"
    >
      <p>You can only use one promo code or reward per order. {directionText}</p>
    </Modal>
  );
};

export default RewardsPromoWarning;
